import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollIntoViewIfNeeded } from '../lib/scrollIntoViewIfNeeded';

export const useScrollHashReferenceToView = () => {
  const location = useLocation();
  const SCROLL_TIMEOUT_MS = 100;

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    if (location.hash) {
      const element = document.getElementById(location.hash.replace('#', ''));
      if (element) {
        timeoutId = setTimeout(() => {
          scrollIntoViewIfNeeded(element, { scrollMode: 'always', behavior: 'auto' });
        }, SCROLL_TIMEOUT_MS);
      }
    }

    return () => {
      if (timeoutId !== undefined) clearTimeout(timeoutId);
    };
  }, [location]);
};
